module.exports = __webpack_public_path__ + "img/perks_I Single Game Ticket PreSale.50501096.jpg";